import { DataTableCol } from "../../../components/data-table/types";

export const TicketDataGridCols: DataTableCol[] = [
    {
        title: 'From',
        control: 'name',
        sortable: true,
        canShowColumn: true
        // type: 'link',
        // action: 'link'
    },
    {
        title: 'Subject',
        control: 'subject',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Created Date',
        control: 'created_dt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Status',
        control: 'ticket_status',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Messages',
        control: 'view',
        canShowColumn: true
    }
];